const data = {
  productData: [
    {
      id: 1,
      img: "./img2/img1.jpg",
      title: "Acrylic Phone Stand",
      desc: "",
      price: 1200,
      unit: "/ pc(s)"
    },
    {
      id: 2,
      img: "./img2/img2.jpg",
      title: "Ajustable Phone Stand",
      desc: "",
      price: 1500,
      unit: "/ pc(s)"
    },
    {
      id: 3,
      img: "./img2/img3.jpg",
      title: "B39 Wireless Headphone",
      desc: "",
      price: 1300,
      unit: "/ pc(s)"
    },
    {
      id: 8,
      img: "./img2/img8.jpg",
      title: "Car Phone Holder",
      desc: "",
      price: 2000,
      unit: "/ pc(s)"
    },
    {
      id: 5,
      img: "./img2/img5.jpg",
      title: "Wireless Earphones",
      desc: "",
      price: 1600,
      unit: "/ pc(s)"
    },
    {
      id: 6,
      img: "./img2/img6.jpg",
      title: "Adjustable Tablet Stand",
      desc: "",
      price: 1200,
      unit: "/ pc(s)"
    },
    {
      id: 7,
      img: "./img2/img7.jpg",
      title: "Car Charger Holder",
      desc: "",
      price: 1000,
      unit: "/ pc(s)"
    },
    {
      id: 9,
      img: "./img2/img9.jpg",
      title: "Flexible Phone Holder",
      desc: "",
      price: 2000,
      unit: "/ pc(s)"
    },
    {
      id: 4,
      img: "./img2/img4.jpg",
      title: "Loncaster Phone Holder",
      desc: "",
      price: 1100,
      unit: "/ pc(s)"
    },

    {
      id: 10,
      img: "./img2/img10.jpg",
      title: "Phone Screen Magnifier",
      desc: "",
      price: 2500,
      unit: "/ pc(s)"
    },
    {
      id: 11,
      img: "./img2/img11.jpg",
      title: "PopSockets Tablets",
      desc: "",
      price: 1900,
      unit: "/ pc(s)"
    },
    {
      id: 12,
      img: "./img2/img12.jpg",
      title: "Adjustable Camera Stand",
      desc: "",
      price: 3500,
      unit: "/ pc(s)"
    },
    {
      id: 13,
      img: "./img2/img13.jpg",
      title: "Shower Phone Holder",
      desc: "",
      price: 1500,
      unit: "/ pc(s)"
    },
    {
      id: 14,
      img: "./img2/img14.jpg",
      title: "Wire Cell Phone Ring",
      desc: "",
      price: 1400,
      unit: "/ pc(s)"
    },
    {
      id: 15,
      img: "./img2/img15.jpg",
      title: "Car Phone Mount",
      desc: "",
      price: 1900,
      unit: "/ pc(s)"
    },
    {
      id: 16,
      img: "./img2/img1.jpg",
      title: "Bluetooth Speaker Stand ",
      desc: "",
      price: 1300,
      unit: "/ pc(s)"
    }
  ]
};

export default data;